import React, { useState, useEffect } from "react";
import { useAuth } from "../context/AuthContext";
import api from "../utils/api";

const EUR_TO_KMF = 491.96;
const toKMF = (eur) => Math.round(parseFloat(eur || 0) * EUR_TO_KMF).toLocaleString("fr-FR");
const toEUR = (eur) => parseFloat(eur || 0).toFixed(2);

export default function AdminPage() {
  const { user, logout } = useAuth();
  const [tab, setTab] = useState(0);
  const [dashboard, setDashboard] = useState(null);
  const [sales, setSales] = useState([]);
  const [cancelledTickets, setCancelledTickets] = useState([]);
  const [merchants, setMerchants] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [userForm, setUserForm] = useState({ name: "", email: "", phone: "", password: "", role: "merchant", shop_name: "" });
  const [eventForm, setEventForm] = useState({ name: "", date: "", end_date: "", location: "", description: "", commission_rate: 10 });
  const [categories, setCategories] = useState([{ name: "Standard", price: 10, total_tickets: 100 }]);
  const [imageFile, setImageFile] = useState(null);
  const [commissions, setCommissions] = useState([]);
  const [commHistory, setCommHistory] = useState([]);
  const [commLoading, setCommLoading] = useState(false);
  const [showPastEvents, setShowPastEvents] = useState(false);
  const [payNote, setPayNote] = useState({ agent: "", lieu: "", note: "", payment_date: "" });
  const [selectedMerchant, setSelectedMerchant] = useState(null);
  const [selectedEvents, setSelectedEvents] = useState([]);
  const [payingId, setPayingId] = useState(null);
  const [imagePreview, setImagePreview] = useState(null);
  const [userPhoto, setUserPhoto] = useState(null);
  const [userPhotoPreview, setUserPhotoPreview] = useState(null);

  useEffect(() => {
    loadDashboard();
    loadSales();
    loadMerchants();
    const interval = setInterval(() => { loadDashboard(); }, 60000);
    return () => clearInterval(interval);
  }, []);
  useEffect(() => {
    if (tab === 1) loadSales();
    if (tab === 2) loadMerchants();
    if (tab === 5) loadCommissions();
    if (tab === 6) loadCancelledTickets();
  }, [tab]);

  const loadCommissions = async () => {
    setCommLoading(true);
    try {
      const [commRes, histRes] = await Promise.all([
        api.get('/admin/commissions'),
        api.get('/admin/commissions/history')
      ]);
      setCommissions(commRes.data);
      setCommHistory(histRes.data);
    } catch(e) { console.error(e); }
    finally { setCommLoading(false); }
  };

    const handlePayCommissions = async () => {
    if (!selectedMerchant) { setError("Selectionnez un commercant"); return; }
    if (!payNote.agent || !payNote.lieu) {
      setError("Nom de l'agent et lieu de paiement obligatoires");
      return;
    }
    setPayingId(selectedMerchant.merchant_id);
    try {
      const noteStr = "Agent: " + payNote.agent + " | Lieu: " + payNote.lieu + (payNote.note ? " | Note: " + payNote.note : "");
      const payload = {
        merchant_id: selectedMerchant.merchant_id,
        event_ids: selectedEvents.length > 0 ? selectedEvents : null,
        note: noteStr,
        payment_date: payNote.payment_date || null
      };
      await api.post('/admin/commissions/pay', payload);
      setSuccess('Commissions payees avec succes !');
      setPayNote({ agent: "", lieu: "", note: "", payment_date: "" });
      setSelectedMerchant(null);
      setSelectedEvents([]);
      loadCommissions();
    } catch(e) {
      setError(e.response && e.response.data ? e.response.data.error : 'Erreur paiement');
    } finally { setPayingId(null); }
  };

  const loadDashboard = async () => {
    setLoading(true);
    try { const res = await api.get("/admin/dashboard"); setDashboard(res.data); }
    catch { setError("Erreur chargement dashboard"); }
    finally { setLoading(false); }
  };

  const loadSales = async () => {
    try { const res = await api.get("/admin/sales?limit=50"); setSales(res.data); } catch {}
  };

  const loadCancelledTickets = async () => {
    try { const res = await api.get("/admin/cancelled-tickets?limit=50"); setCancelledTickets(res.data); } catch {}
  };

  const handleCancelTicket = async (ticketId, reference) => {
    if (!window.confirm("Annuler le billet #" + reference + " ? Cette action est irreversible.")) return;
    try {
      await api.post("/admin/tickets/" + ticketId + "/cancel", { reason: "Annulation admin" });
      setSuccess("Billet #" + reference + " annule avec succes");
      loadSales();
      loadDashboard();
    } catch(e) {
      setError(e.response && e.response.data ? e.response.data.error : "Erreur annulation");
    }
  };

  const loadMerchants = async () => {
    try { const res = await api.get("/admin/merchants"); setMerchants(res.data); } catch {}
  };

  const handleCreateUser = async (e) => {
    e.preventDefault(); setError(""); setSuccess("");
    try {
      const formData = new FormData();
      Object.keys(userForm).forEach(k => formData.append(k, userForm[k]));
      if (userPhoto) formData.append("photo", userPhoto);
      await api.post("/admin/users", formData, { headers: { "Content-Type": "multipart/form-data" } });
      setSuccess("Utilisateur cr&eacute;&eacute; avec succ&egrave;s !");
      setUserForm({ name: "", email: "", phone: "", password: "", role: "merchant", shop_name: "" });
      setUserPhoto(null); setUserPhotoPreview(null);
    } catch (err) {
      setError(err.response && err.response.data ? err.response.data.error : "Erreur cr&eacute;ation utilisateur");
    }
  };

  const addCategory = () => setCategories([...categories, { name: "", price: 0, total_tickets: 50 }]);
  const removeCategory = (i) => { if (categories.length > 1) setCategories(categories.filter((_, idx) => idx !== i)); };
  const updateCategory = (i, field, value) => { const u = [...categories]; u[i][field] = value; setCategories(u); };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) { setImageFile(file); setImagePreview(URL.createObjectURL(file)); }
  };

  const handleUserPhotoChange = (e) => {
    const file = e.target.files[0];
    if (file) { setUserPhoto(file); setUserPhotoPreview(URL.createObjectURL(file)); }
  };

  const handleCreateEvent = async (e) => {
    e.preventDefault(); setError(""); setSuccess("");
    try {
      const formData = new FormData();
      formData.append("name", eventForm.name);
      formData.append("date", eventForm.date);
      formData.append("end_date", eventForm.end_date);
      formData.append("location", eventForm.location);
      formData.append("description", eventForm.description);
      formData.append("commission_rate", eventForm.commission_rate);
      formData.append("categories", JSON.stringify(categories));
      if (imageFile) formData.append("image", imageFile);
      await api.post("/events", formData, { headers: { "Content-Type": "multipart/form-data" } });
      setSuccess("&Eacute;v&eacute;nement cr&eacute;&eacute; avec succ&egrave;s !");
      setEventForm({ name: "", date: "", end_date: "", location: "", description: "", commission_rate: 10 });
      setCategories([{ name: "Standard", price: 10, total_tickets: 100 }]);
      setImageFile(null); setImagePreview(null);
    } catch (err) {
      setError(err.response && err.response.data ? err.response.data.error : "Erreur cr&eacute;ation &eacute;v&eacute;nement");
    }
  };

  const TABS = ["Dashboard", "Ventes", "Commer&ccedil;ants", "Cr&eacute;er utilisateur", "Cr&eacute;er &eacute;v&eacute;nement", "Commissions", "Billets annul&eacute;s"];

  const BarChart = ({ data, labelKey, valueKey, color }) => {
    if (!data || data.length === 0) return <div style={{color:"var(--gray-400)",fontSize:13,textAlign:"center",padding:20}}>Aucune donnee</div>;
    const max = Math.max(...data.map(d => parseFloat(d[valueKey]) || 0));
    return (
      <div style={{display:"flex",alignItems:"flex-end",gap:4,height:120,padding:"0 4px"}}>
        {data.map((d, i) => {
          const pct = max > 0 ? (parseFloat(d[valueKey]) || 0) / max * 100 : 0;
          return (
            <div key={i} style={{flex:1,display:"flex",flexDirection:"column",alignItems:"center",gap:4}}>
              <div style={{fontSize:9,color:"var(--gray-400)"}}>{Math.round(parseFloat(d[valueKey]) || 0)}</div>
              <div style={{width:"100%",background:color || "var(--blue)",borderRadius:"3px 3px 0 0",height:pct+"%",minHeight:2,transition:"height 0.3s"}} />
              <div style={{fontSize:9,color:"var(--gray-400)",whiteSpace:"nowrap",overflow:"hidden",textOverflow:"ellipsis",maxWidth:"100%"}}>{d[labelKey]}</div>
            </div>
          );
        })}
      </div>
    );
  };

  return (
    <div className="app-layout">
      <aside className="sidebar">
        <div className="sidebar-logo">
          <div className="logo-mark">
            <div className="logo-icon">&#127915;</div>
            <div><div className="logo-text">ComoTicket</div><div className="logo-sub">Administration</div></div>
          </div>
        </div>
        <nav className="sidebar-nav">
          <div className="nav-section">
            <div className="nav-section-label">Navigation</div>
            {TABS.map((t, i) => (
              <button key={i} className={"nav-item " + (tab === i ? "active" : "")} onClick={() => { setTab(i); setError(""); setSuccess(""); }}>
                <span className="nav-icon" dangerouslySetInnerHTML={{__html: ["&#128202;","&#129534;","&#127978;","&#128100;","&#128197;","&#128184;"][i]}} /><span dangerouslySetInnerHTML={{__html: t}} />
              </button>
            ))}
          </div>
        </nav>
        <div style={{padding:"8px 12px"}}>
          <a href="/reports" style={{display:"flex",alignItems:"center",gap:8,padding:"10px 12px",borderRadius:8,background:"#eff6ff",color:"#2563eb",textDecoration:"none",fontWeight:700,fontSize:13}}>
            <span>&#128202;</span> Rapports comptables
          </a>
        </div>
        <div className="sidebar-footer">
          <div className="user-card">
            <div className="avatar" style={{background:"#7c3aed"}}>{user && user.name ? user.name[0].toUpperCase() : "A"}</div>
            <div className="user-info">
              <div className="user-name">{user && user.name}</div>
              <div className="user-role">Administrateur</div>
            </div>
            <button className="logout-btn" onClick={logout}>&#8618;</button>
          </div>
        </div>
      </aside>

      <main className="main-content">
        <div className="page-header">
          <div className="page-title" dangerouslySetInnerHTML={{__html: TABS[tab]}} />
          <div className="page-subtitle">Administration ComoTicket</div>
        </div>
        <div className="page-body">
          {error && <div className="error-msg" style={{marginBottom:16}}><span dangerouslySetInnerHTML={{__html: "&#9888; " + error}} /></div>}
          {success && <div style={{background:"var(--green-pale)",color:"#065f46",borderRadius:8,padding:"10px 14px",fontSize:13,marginBottom:16}}><span dangerouslySetInnerHTML={{__html: "&#10003; " + success}} /></div>}

          {tab === 0 && (
            loading ? <div className="loading-screen"><div className="spinner" /></div> : dashboard && (
              <>
                <div className="stats-grid">
                  <div className="stat-card">
                    <div className="stat-icon blue">&#127915;</div>
                    <div><div className="stat-label">Billets vendus</div><div className="stat-value">{parseInt(dashboard.totals.total_sales || 0).toLocaleString("fr-FR")}</div></div>
                  </div>
                  <div className="stat-card">
                    <div className="stat-icon green">&#128176;</div>
                    <div>
                      <div className="stat-label">Chiffre d affaires</div>
                      <div className="stat-value">{toKMF(dashboard.totals.total_revenue)} KMF</div>
                      <div className="stat-change">{toEUR(dashboard.totals.total_revenue)} EUR</div>
                    </div>
                  </div>
                  <div className="stat-card">
                    <div className="stat-icon amber">&#128200;</div>
                    <div>
                      <div className="stat-label">Commissions</div>
                      <div className="stat-value">{toKMF(dashboard.totals.total_commissions)} KMF</div>
                      <div className="stat-change">{toEUR(dashboard.totals.total_commissions)} EUR</div>
                    </div>
                  </div>
                  <div className="stat-card">
                    <div className="stat-icon purple">&#127978;</div>
                    <div><div className="stat-label">Commer&ccedil;ants actifs</div><div className="stat-value">{parseInt(dashboard.totals.active_merchants || 0)}</div></div>
                  </div>
                </div>

                <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:20,marginBottom:20}}>
                  <div className="card">
                    <div className="card-header"><div className="card-title">Ventes par jour (30 derniers jours)</div></div>
                    <BarChart data={dashboard.sales_by_day} labelKey="day" valueKey="count" color="var(--blue)" />
                  </div>
                  <div className="card">
                    <div className="card-header"><div className="card-title">Ventes par heure (7 derniers jours)</div></div>
                    <BarChart data={dashboard.sales_by_hour.map(d => ({...d, hour: d.hour + "h"}))} labelKey="hour" valueKey="count" color="var(--cyan, #06b6d4)" />
                  </div>
                </div>

                <div style={{display:"grid",gridTemplateColumns:"1fr 1fr 1fr",gap:20,marginBottom:20}}>
                  <div className="card">
                    <div className="card-header"><div className="card-title">Par cat&eacute;gorie</div></div>
                    {dashboard.sales_by_category && dashboard.sales_by_category.length > 0 ? dashboard.sales_by_category.map((cat, i) => (
                      <div key={i} style={{display:"flex",justifyContent:"space-between",alignItems:"center",padding:"10px 0",borderBottom:i < dashboard.sales_by_category.length-1?"1px solid var(--gray-100)":"none"}}>
                        <div>
                          <div style={{fontWeight:600,fontSize:13}}>{cat.category_name || "Standard"}</div>
                          <div style={{fontSize:11,color:"var(--gray-400)"}}>{cat.tickets_sold} billets</div>
                        </div>
                        <div style={{textAlign:"right"}}>
                          <div style={{fontWeight:700,fontSize:13}}>{toKMF(cat.revenue)} KMF</div>
                        </div>
                      </div>
                    )) : <div style={{color:"var(--gray-400)",fontSize:13}}>Aucune donnee</div>}
                  </div>
                  <div className="card">
                    <div className="card-header"><div className="card-title">Ventes par &eacute;v&eacute;nement</div></div>
                    {dashboard.by_event.map((evt, i) => (
                      <div key={i} style={{display:"flex",justifyContent:"space-between",alignItems:"center",padding:"10px 0",borderBottom:i < dashboard.by_event.length-1?"1px solid var(--gray-100)":"none"}}>
                        <div>
                          <div style={{fontWeight:600,fontSize:13}}>
                            {evt.name}
                            {evt.date && new Date(evt.date) < new Date() && <span style={{marginLeft:6,background:"#fee2e2",color:"#dc2626",padding:"1px 6px",borderRadius:100,fontSize:10,fontWeight:700}}>Pass&eacute;</span>}
                          </div>
                          <div style={{fontSize:11,color:"var(--gray-400)"}}>{evt.tickets_sold} billets</div>
                        </div>
                        <div style={{textAlign:"right"}}>
                          <div style={{fontWeight:700,fontSize:13}}>{toKMF(evt.revenue)} KMF</div>
                          <div style={{fontSize:11,color:"var(--red)"}}>-{toKMF(evt.commissions)} KMF</div>
                        </div>
                      </div>
                    ))}
                  </div>
                  <div className="card">
                    <div className="card-header"><div className="card-title">Top commer&ccedil;ants</div></div>
                    {dashboard.top_merchants.slice(0,5).map((m, i) => (
                      <div key={i} style={{display:"flex",justifyContent:"space-between",alignItems:"center",padding:"10px 0",borderBottom:i<4?"1px solid var(--gray-100)":"none"}}>
                        <div style={{display:"flex",alignItems:"center",gap:8}}>
                          <div style={{width:24,height:24,borderRadius:"50%",background:"var(--blue)",display:"flex",alignItems:"center",justifyContent:"center",fontSize:11,fontWeight:700,color:"white"}}>{i+1}</div>
                          <div>
                            <div style={{fontWeight:600,fontSize:13}}>{m.shop_name || m.name}</div>
                            <div style={{fontSize:11,color:"var(--gray-400)"}}>{m.tickets_sold} billets</div>
                          </div>
                        </div>
                        <div style={{textAlign:"right"}}>
                          <div style={{fontWeight:700,fontSize:13}}>{toKMF(m.revenue)} KMF</div>
                          <div style={{fontSize:11,color:"var(--red)"}}>{toKMF(m.commission_due)} KMF</div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>

                <div className="card">
                  <div style={{display:"flex",justifyContent:"space-between",alignItems:"center"}}>
                    <div>
                      <div style={{fontSize:14,color:"var(--gray-600)"}}>Commissions totales &agrave; r&eacute;cup&eacute;rer</div>
                      <div style={{fontSize:32,fontWeight:800,color:"var(--navy)"}}>{toKMF(dashboard.pending_commissions)} KMF</div>
                      <div style={{fontSize:14,color:"var(--gray-400)"}}>{toEUR(dashboard.pending_commissions)} EUR</div>
                    </div>
                    <div style={{fontSize:48}}>&#128142;</div>
                  </div>
                </div>
              </>
            )
          )}

          {tab === 1 && (
            <div className="card">
              <div className="card-header">
                <div className="card-title">Toutes les ventes</div>
                <button className="btn btn-ghost" onClick={loadSales}>Actualiser</button>
              </div>
              <div style={{overflowX:"auto"}}>
                <table>
                  <thead>
                    <tr><th>Reference</th><th>&Eacute;v&eacute;nement</th><th>Commer&ccedil;ant</th><th>Cat&eacute;gorie</th><th>Prix</th><th>Commission</th><th>Date</th><th>Statut</th><th>Action</th></tr>
                  </thead>
                  <tbody>
                    {sales.length === 0 && <tr><td colSpan={8} style={{textAlign:"center",padding:32,color:"var(--gray-400)"}}>Aucune vente</td></tr>}
                    {sales.map((s) => (
                      <tr key={s.id}>
                        <td><span className="sale-ref" style={{fontSize:11}}>#{s.sale_reference}</span></td>
                        <td style={{fontWeight:600}}>{s.event_name}</td>
                        <td>
                          <div>{s.shop_name || s.merchant_name}</div>
                          {s.shop_name && <div style={{fontSize:11,color:"var(--gray-400)"}}>{s.merchant_name}</div>}
                        </td>
                        <td><span className="badge badge-blue">{s.category_name || "Standard"}</span></td>
                        <td><strong>{toKMF(s.price)} KMF</strong><div style={{fontSize:10,color:"var(--gray-400)"}}>{s.price} EUR</div></td>
                        <td style={{color:"var(--red)"}}>-{toKMF(s.commission)} KMF</td>
                        <td style={{fontSize:12,color:"var(--gray-600)"}}>{new Date(s.created_at).toLocaleDateString("fr-FR")}</td>
                        <td><span className={"badge badge-"+(s.ticket_status==="used"?"gray":"green")}>{s.ticket_status==="sold"?"Vendu":"Utilise"}</span></td>
                        <td>
                          {s.ticket_status === "sold" && (
                            <button className="btn btn-ghost" style={{color:"var(--red)",fontSize:12}} onClick={() => handleCancelTicket(s.ticket_id, s.sale_reference)}>Annuler</button>
                          )}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          )}

          {tab === 2 && (
            <div className="card">
              <div className="card-header">
                <div className="card-title">Liste des commer&ccedil;ants</div>
                <button className="btn btn-ghost" onClick={loadMerchants}>Actualiser</button>
              </div>
              <div style={{overflowX:"auto"}}>
                <table>
                  <thead>
                    <tr><th>Magasin</th><th>Nom</th><th>Email</th><th>T&eacute;l&eacute;phone</th><th>Billets vendus</th><th>Chiffre affaires</th><th>Commission due</th></tr>
                  </thead>
                  <tbody>
                    {merchants.length === 0 && <tr><td colSpan={7} style={{textAlign:"center",padding:32,color:"var(--gray-400)"}}>Aucun commer&ccedil;ant</td></tr>}
                    {merchants.map((m) => (
                      <tr key={m.id}>
                        <td><strong>{m.shop_name || "-"}</strong></td>
                        <td>{m.name}</td>
                        <td style={{fontSize:13}}>{m.email}</td>
                        <td style={{fontSize:13}}>{m.phone || "-"}</td>
                        <td><span className="badge badge-blue">{m.tickets_sold}</span></td>
                        <td><strong>{toKMF(m.total_revenue)} KMF</strong><div style={{fontSize:10,color:"var(--gray-400)"}}>{toEUR(m.total_revenue)} EUR</div></td>
                        <td><span style={{color:"var(--red)",fontWeight:600}}>{toKMF(m.commission_due)} KMF</span><div style={{fontSize:10,color:"var(--gray-400)"}}>{toEUR(m.commission_due)} EUR</div></td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          )}

          {tab === 3 && (
            <div style={{maxWidth:480}}>
              <div className="card">
                <div className="card-header"><div className="card-title">Cr&eacute;er un utilisateur</div></div>
                <form onSubmit={handleCreateUser}>
                  <div className="form-group">
                    <label className="form-label">Photo du commer&ccedil;ant</label>
                    <div style={{border:"2px dashed var(--gray-200)",borderRadius:10,padding:16,textAlign:"center",cursor:"pointer",background:"var(--gray-50)"}} onClick={() => document.getElementById("userPhotoInput").click()}>
                      {userPhotoPreview ? (
                        <img src={userPhotoPreview} alt="preview" style={{width:80,height:80,objectFit:"cover",borderRadius:"50%",margin:"0 auto"}} />
                      ) : (
                        <div>
                          <div style={{fontSize:24,marginBottom:6}}>&#128247;</div>
                          <div style={{fontSize:12,color:"var(--gray-600)"}}>Ajouter une photo (optionnel)</div>
                        </div>
                      )}
                    </div>
                    <input id="userPhotoInput" type="file" accept="image/*" style={{display:"none"}} onChange={handleUserPhotoChange} />
                  </div>
                  <div className="form-group">
                    <label className="form-label">Nom complet *</label>
                    <input className="form-input" placeholder="Ali Madi" value={userForm.name} onChange={e => setUserForm({...userForm,name:e.target.value})} required />
                  </div>
                  <div className="form-group">
                    <label className="form-label">Nom du magasin</label>
                    <input className="form-input" placeholder="Boutique Ali - Moroni" value={userForm.shop_name} onChange={e => setUserForm({...userForm,shop_name:e.target.value})} />
                  </div>
                  <div className="form-group">
                    <label className="form-label">Email *</label>
                    <input type="email" className="form-input" placeholder="ali@comoticket.km" value={userForm.email} onChange={e => setUserForm({...userForm,email:e.target.value})} required />
                  </div>
                  <div className="form-group">
                    <label className="form-label">T&eacute;l&eacute;phone</label>
                    <input className="form-input" placeholder="+269 321 0000" value={userForm.phone} onChange={e => setUserForm({...userForm,phone:e.target.value})} />
                  </div>
                  <div className="form-group">
                    <label className="form-label">Mot de passe *</label>
                    <input type="password" className="form-input" placeholder="********" value={userForm.password} onChange={e => setUserForm({...userForm,password:e.target.value})} required />
                  </div>
                  <div className="form-group">
                    <label className="form-label">R&ocirc;le *</label>
                    <select className="form-select" value={userForm.role} onChange={e => setUserForm({...userForm,role:e.target.value})}>
                      <option value="merchant">Commer&ccedil;ant</option>
                      <option value="controller">Contr&ocirc;leur</option>
                      <option value="admin">Administrateur</option>
                    </select>
                  </div>
                  <button type="submit" className="btn btn-primary btn-lg btn-full">Cr&eacute;er l'utilisateur</button>
                </form>
              </div>
            </div>
          )}

          {tab === 4 && (
            <div style={{maxWidth:640}}>
              <div className="card">
                <div className="card-header"><div className="card-title">Cr&eacute;er un &eacute;v&eacute;nement</div></div>
                <form onSubmit={handleCreateEvent}>
                  <div className="form-group">
                    <label className="form-label">Image de l'&eacute;v&eacute;nement</label>
                    <div style={{border:"2px dashed var(--gray-200)",borderRadius:10,padding:20,textAlign:"center",cursor:"pointer",background:"var(--gray-50)"}} onClick={() => document.getElementById("imageInput").click()}>
                      {imagePreview ? <img src={imagePreview} alt="preview" style={{width:"100%",height:180,objectFit:"cover",borderRadius:8}} /> : (
                        <div>
                          <div style={{fontSize:32,marginBottom:8}}>&#128444;</div>
                          <div style={{fontSize:13,color:"var(--gray-600)"}}>Cliquer pour ajouter une image</div>
                          <div style={{fontSize:11,color:"var(--gray-400)",marginTop:4}}>JPG, PNG, WEBP - max 10MB - Format 16:9</div>
                        </div>
                      )}
                    </div>
                    <input id="imageInput" type="file" accept="image/*" style={{display:"none"}} onChange={handleImageChange} />
                  </div>
                  <div className="form-group">
                    <label className="form-label">Nom de l'&eacute;v&eacute;nement *</label>
                    <input className="form-input" placeholder="Concert Fally Ipupa" value={eventForm.name} onChange={e => setEventForm({...eventForm,name:e.target.value})} required />
                  </div>
                  <div className="form-group">
                    <label className="form-label">Date et heure de d&eacute;but *</label>
                    <input type="datetime-local" className="form-input" value={eventForm.date} onChange={e => setEventForm({...eventForm,date:e.target.value})} required />
                  </div>
                  <div className="form-group">
                    <label className="form-label">Date et heure de fin *</label>
                    <input type="datetime-local" className="form-input" value={eventForm.end_date} onChange={e => setEventForm({...eventForm,end_date:e.target.value})} required />
                  </div>
                  <div className="form-group">
                    <label className="form-label">Lieu *</label>
                    <input className="form-input" placeholder="Stade de Moroni" value={eventForm.location} onChange={e => setEventForm({...eventForm,location:e.target.value})} required />
                  </div>
                  <div className="form-group">
                    <label className="form-label">Description</label>
                    <input className="form-input" placeholder="Description..." value={eventForm.description} onChange={e => setEventForm({...eventForm,description:e.target.value})} />
                  </div>
                  <div className="form-group">
                    <label className="form-label">Commission (%)</label>
                    <input type="number" className="form-input" min={0} max={50} value={eventForm.commission_rate} onChange={e => setEventForm({...eventForm,commission_rate:e.target.value === "" ? "" : parseFloat(e.target.value)})} />
                  </div>
                  <div style={{marginBottom:16}}>
                    <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:12}}>
                      <label className="form-label" style={{margin:0}}>Cat&eacute;gories de places *</label>
                      <button type="button" className="btn btn-ghost" style={{fontSize:12,padding:"6px 12px"}} onClick={addCategory}>+ Ajouter cat&eacute;gorie</button>
                    </div>
                    {categories.map((cat, index) => (
                      <div key={index} style={{background:"var(--gray-50)",border:"1px solid var(--gray-200)",borderRadius:10,padding:16,marginBottom:10}}>
                        <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:10}}>
                          <span style={{fontSize:13,fontWeight:600,color:"var(--navy)"}}>Cat&eacute;gorie {index+1}</span>
                          {categories.length > 1 && <button type="button" onClick={() => removeCategory(index)} style={{background:"none",border:"none",color:"var(--red)",cursor:"pointer",fontSize:16}}>x</button>}
                        </div>
                        <div style={{display:"grid",gridTemplateColumns:"2fr 1fr 1fr",gap:10}}>
                          <div>
                            <label className="form-label">Nom</label>
                            <input className="form-input" placeholder="Standard" value={cat.name} onChange={e => updateCategory(index,"name",e.target.value)} required />
                          </div>
                          <div>
                            <label className="form-label">Prix (EUR)</label>
                            <input type="number" className="form-input" min={0} step="0.01" value={cat.price} onChange={e => updateCategory(index,"price",parseFloat(e.target.value))} required />
                            {cat.price > 0 && <div style={{fontSize:11,color:"var(--blue)",marginTop:4}}>{toKMF(cat.price)} KMF</div>}
                          </div>
                          <div>
                            <label className="form-label">Nb places</label>
                            <input type="number" className="form-input" min={1} value={cat.total_tickets} onChange={e => updateCategory(index,"total_tickets",parseInt(e.target.value))} required />
                          </div>
                        </div>
                      </div>
                    ))}
                    <div style={{background:"#dbeafe",borderRadius:8,padding:"10px 14px",fontSize:13,color:"#1e40af"}}>
                      Total places : <strong>{categories.reduce((sum,cat) => sum+(parseInt(cat.total_tickets)||0),0)}</strong>
                    </div>
                  </div>
                  <button type="submit" className="btn btn-success btn-lg btn-full">Cr&eacute;er l'&eacute;v&eacute;nement</button>
                </form>
              </div>
            </div>
          )}

          {tab === 5 && (
            <div>
              {commLoading ? (
                <div style={{padding:32,textAlign:"center",color:"var(--gray-400)"}}>Chargement...</div>
              ) : (
                <>
                  <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:20,marginBottom:20}}>
                    <div className="card">
                      <div className="card-header"><div className="card-title">1. S&eacute;lectionner un commer&ccedil;ant</div></div>
                      <div style={{padding:"0 16px 16px"}}>
                        {commissions.filter(m => parseFloat(m.commission_due) > 0).map((m) => (
                          <div key={m.merchant_id} onClick={() => { setSelectedMerchant(m); setSelectedEvents([]); }} style={{padding:"10px 14px",borderRadius:10,marginBottom:8,cursor:"pointer",border:"2px solid " + (selectedMerchant && selectedMerchant.merchant_id === m.merchant_id ? "var(--blue)" : "var(--gray-200)"),background:selectedMerchant && selectedMerchant.merchant_id === m.merchant_id ? "#eff6ff" : "white"}}>
                            <div style={{fontWeight:700,fontSize:14}}>{m.merchant_name}</div>
                            <div style={{fontSize:12,color:"var(--gray-500)"}}>{m.shop_name || ""} - {m.phone || ""}</div>
                            <div style={{fontSize:13,color:"var(--green)",fontWeight:700,marginTop:4}}>Due: {Math.round(parseFloat(m.commission_due)*491.96).toLocaleString("fr-FR")} KMF</div>
                          </div>
                        ))}
                        {commissions.filter(m => parseFloat(m.commission_due) > 0).length === 0 && (
                          <div style={{padding:20,textAlign:"center",color:"var(--gray-400)"}}>Aucune commission due</div>
                        )}
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header"><div className="card-title">2. D&eacute;tails du paiement</div></div>
                      <div style={{padding:"0 16px 16px"}}>
                        {selectedMerchant ? (
                          <>
                            <div className="form-group">
                              <label className="form-label">&Eacute;v&eacute;nements &agrave; payer (laissez vide pour tout payer)</label>
                              {selectedMerchant.events && selectedMerchant.events.filter(e => e && parseFloat(e.commission_due) > 0).map((evt, i) => (
                                <label key={i} style={{display:"flex",alignItems:"center",gap:8,padding:"6px 0",cursor:"pointer",fontSize:13}}>
                                  <input type="checkbox" checked={selectedEvents.includes(evt.event_id)} onChange={e => {
                                    if (e.target.checked) setSelectedEvents([...selectedEvents, evt.event_id]);
                                    else setSelectedEvents(selectedEvents.filter(id => id !== evt.event_id));
                                  }} />
                                  {evt.event_name} - <strong>{Math.round(parseFloat(evt.commission_due)*491.96).toLocaleString("fr-FR")} KMF</strong>
                                </label>
                              ))}
                            </div>
                            <div className="form-group">
                              <label className="form-label">Nom et pr&eacute;nom de l'agent *</label>
                              <input className="form-input" placeholder="Ex: Mohamed Ali" value={payNote.agent} onChange={e => setPayNote({...payNote, agent: e.target.value})} />
                            </div>
                            <div className="form-group">
                              <label className="form-label">Lieu du paiement *</label>
                              <input className="form-input" placeholder="Ex: Boutique Ali - Moroni" value={payNote.lieu} onChange={e => setPayNote({...payNote, lieu: e.target.value})} />
                            </div>
                            <div className="form-group">
                              <label className="form-label">Date et heure du paiement *</label>
                              <input type="datetime-local" className="form-input" value={payNote.payment_date} onChange={e => setPayNote({...payNote, payment_date: e.target.value})} />
                            </div>
                            <div className="form-group">
                              <label className="form-label">Note suppl&eacute;mentaire</label>
                              <input className="form-input" placeholder="Remarque optionnelle..." value={payNote.note} onChange={e => setPayNote({...payNote, note: e.target.value})} />
                            </div>
                            <button className="btn btn-primary btn-lg btn-full" onClick={handlePayCommissions} disabled={payingId === selectedMerchant.merchant_id}>
                              {payingId === selectedMerchant.merchant_id ? "Traitement..." : selectedEvents.length > 0 ? "Payer " + selectedEvents.length + " evenement(s)" : "Tout payer"}
                            </button>
                          </>
                        ) : (
                          <div style={{padding:40,textAlign:"center",color:"var(--gray-400)"}}>S&eacute;lectionnez un commer&ccedil;ant</div>
                        )}
                      </div>
                    </div>
                  </div>

                  <div className="card" style={{marginBottom:24}}>
                    <div className="card-header"><div className="card-title">Toutes les commissions</div></div>
                    <div style={{overflowX:"auto"}}>
                      <table>
                        <thead>
                          <tr><th>Commer&ccedil;ant</th><th>Magasin</th><th>T&eacute;l.</th><th>Commission due</th><th>Commission pay&eacute;e</th></tr>
                        </thead>
                        <tbody>
                          {commissions.map((m) => (
                            <tr key={m.merchant_id} style={{cursor:"pointer",background:selectedMerchant && selectedMerchant.merchant_id === m.merchant_id ? "#eff6ff" : ""}} onClick={() => { if(parseFloat(m.commission_due)>0){setSelectedMerchant(m); setSelectedEvents([]);} }}>
                              <td style={{fontWeight:600}}>{m.merchant_name}</td>
                              <td>{m.shop_name || "-"}</td>
                              <td>{m.phone || "-"}</td>
                              <td style={{color:"var(--green)",fontWeight:700}}>{Math.round(parseFloat(m.commission_due)*491.96).toLocaleString("fr-FR")} KMF</td>
                              <td style={{color:"#2563eb",fontWeight:700}}>{Math.round(parseFloat(m.commission_paid)*491.96).toLocaleString("fr-FR")} KMF</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>

                  <div className="card">
                    <div className="card-header"><div className="card-title">Historique des paiements</div></div>
                    <div style={{overflowX:"auto"}}>
                      <table>
                        <thead>
                          <tr><th>Date</th><th>Commer&ccedil;ant</th><th>Magasin</th><th>&Eacute;v&eacute;nement</th><th>Montant pay&eacute;</th><th>Pay&eacute; par</th><th>Note</th></tr>
                        </thead>
                        <tbody>
                          {commHistory.length === 0 ? (
                            <tr><td colSpan={7} style={{textAlign:"center",padding:32,color:"var(--gray-400)"}}>Aucun paiement effectu&eacute;</td></tr>
                          ) : commHistory.map((p) => (
                            <tr key={p.id}>
                              <td style={{fontSize:12}}>
                                <div style={{fontWeight:600}}>{new Date(p.payment_date || p.created_at).toLocaleDateString("fr-FR",{day:"numeric",month:"short",year:"numeric",hour:"2-digit",minute:"2-digit"})}</div>
                                <div style={{fontSize:11,color:"var(--gray-400)"}}>Enreg.: {new Date(p.created_at).toLocaleDateString("fr-FR",{day:"numeric",month:"short",hour:"2-digit",minute:"2-digit"})}</div>
                              </td>
                              <td style={{fontWeight:600}}>{p.merchant_name}</td>
                              <td>{p.shop_name || "-"}</td>
                              <td>{p.event_name || "Toutes ventes"}</td>
                              <td style={{color:"var(--green)",fontWeight:700}}>{Math.round(parseFloat(p.amount)*491.96).toLocaleString("fr-FR")} KMF</td>
                              <td>{p.paid_by_name}</td>
                              <td style={{fontSize:12,color:"var(--gray-500)"}}>{p.note || "-"}</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </>
              )}
            </div>
          )}
          {tab === 6 && (
            <div className="card">
              <div className="card-header">
                <div className="card-title">Billets annul&eacute;s</div>
                <button className="btn btn-ghost" onClick={loadCancelledTickets}>Actualiser</button>
              </div>
              <div style={{overflowX:"auto"}}>
                <table>
                  <thead>
                    <tr><th>Reference</th><th>&Eacute;v&eacute;nement</th><th>Commer&ccedil;ant</th><th>Cat&eacute;gorie</th><th>Prix</th><th>Commission</th><th>Raison</th><th>Annul&eacute; par</th><th>Date annulation</th></tr>
                  </thead>
                  <tbody>
                    {cancelledTickets.length === 0 && <tr><td colSpan={9} style={{textAlign:"center",padding:32,color:"var(--gray-400)"}}>Aucun billet annul&eacute;</td></tr>}
                    {cancelledTickets.map((c) => (
                      <tr key={c.id}>
                        <td><span className="sale-ref" style={{fontSize:11}}>#{c.sale_reference}</span></td>
                        <td style={{fontWeight:600}}>{c.event_name}</td>
                        <td>
                          <div>{c.shop_name || c.merchant_name}</div>
                          {c.shop_name && <div style={{fontSize:11,color:"var(--gray-400)"}}>{c.merchant_name}</div>}
                        </td>
                        <td><span className="badge badge-blue">{c.category_name || "Standard"}</span></td>
                        <td><strong>{toKMF(c.price)} KMF</strong><div style={{fontSize:10,color:"var(--gray-400)"}}>{c.price} EUR</div></td>
                        <td style={{color:"var(--red)"}}>-{toKMF(c.commission)} KMF</td>
                        <td style={{fontSize:12,color:"var(--gray-600)"}}>{c.reason}</td>
                        <td style={{fontSize:12}}>{c.cancelled_by_name}</td>
                        <td style={{fontSize:12,color:"var(--gray-600)"}}>{new Date(c.cancelled_at).toLocaleString("fr-FR")}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          )}
        </div>
      </main>
    </div>
  );
}